<template>
  <span class="highlight-match">
    <span
      v-for="(part, index) in parts"
      :key="index"
      :class="{ 'highlight-match--hit': is_match(part) }"
    >{{ part }}</span>
  </span>
</template>

<script>
  const escape_regexp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  export default {
    name: 'highlight-match',
    props: {
      text: {
        type: String,
        required: true,
      },
      search: {
        type: String,
        default: '',
      },
    },
    computed: {
      parts() {
        if (!this.search) return [this.text];
        const pattern = new RegExp(`(${escape_regexp(this.search)})`, 'ig');
        return this.text.split(pattern).filter((part) => part !== '');
      },
    },
    methods: {
      is_match(part) {
        if (!this.search) return false;
        return part.toLowerCase() === this.search.toLowerCase();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .highlight-match {
    // `display: contents` makes this wrapper generate no box of its own, so the
    // split spans inherit the surrounding text's styling and layout exactly.
    display: contents;

    &--hit {
      font-weight: bold;
      text-decoration: underline;
      text-decoration-thickness: 3px;
    }
  }
</style>
